// Copyright (c) 2020 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React, { MouseEvent } from "react";

import { Lifecycle, Setter, scrollIntoViewSoon } from "../UiUtil";

interface CancelButtonProps {
  lifecycle: Lifecycle;
  setLifecycle: Setter<Lifecycle>;
  onCancel: () => any;
}

export const CancelButton: React.FC<CancelButtonProps> = ({
  lifecycle,
  setLifecycle,
  onCancel,
}) => {
  async function onClick(event: MouseEvent<HTMLButtonElement>) {
    if (!window.confirm("Really cancel?")) {
      return;
    }

    scrollIntoViewSoon(event.currentTarget);
    onCancel();
    setLifecycle(Lifecycle.VIEWED);
  }

  const disabled =
    lifecycle === Lifecycle.VIEWED ||
    lifecycle === Lifecycle.SAVING ||
    lifecycle === Lifecycle.SAVED;

  return (
    <button type="button" onClick={onClick} disabled={disabled}>
      Cancel
    </button>
  );
};
